import { useState } from "react";
import s from "./index.module.scss";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

const ConfirmModal = ({ visible, handleClose, deletionName }) => {
  const [inputValue, setInputValue] = useState("");
  return (
    <>
      <Modal show={visible} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            Вы уверены, что хотите удалить всю ветку <u>{deletionName}</u>{" "}
            товаров?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input
            className={s.input}
            type="text"
            placeholder="Введите название удаляемой категории"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              handleClose();
              setInputValue("");
            }}
          >
            Отмена
          </Button>
          <Button
            disabled={inputValue === deletionName ? false : true}
            className={inputValue !== deletionName ? s.disabledBtn : null}
            variant="danger"
            onClick={() => {
              handleClose();
              setInputValue("");
            }}
          >
            Удалить
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ConfirmModal;
